import { isArray } from 'lodash';
import { getProjectConditions } from '../projectActions';

export const OCCURRENCE_LOCATION_TAG = 'OccurrenceLocations';
export const OCCURRENCE_LOCATION_STACK_TAG = 'OccurrenceLocationsStack';

export const updateOccurrenceLocation = (
  occurrence,
  toOccurrenceRow,
  toOccurrenceIndex,
  toConditionIndex,
  callback
) => {
  return async (dispatch, getState, { apiClient }) => {
    const projectId = getState().projects.single.active.id;
    const conditionId = getState().projects.single.conditions[toConditionIndex].id;

    if (!isArray(occurrence)) {
      occurrence.x_location = toOccurrenceRow;
      occurrence.y_location = toOccurrenceIndex;
      occurrence.project_id = projectId;
      occurrence.condition_id = conditionId;

      await apiClient.call(
        OCCURRENCE_LOCATION_TAG,
        'updateOccurrenceLocation',
        {
          id: occurrence.id
        },
        occurrence
      );
    } else {
      const ids = [];
      occurrence.forEach(occurrenceItem => {
        ids.push(occurrenceItem.id);
      });

      await apiClient.call(
        OCCURRENCE_LOCATION_TAG,
        'updateOccurrenceLocationStack',
        {
          'id[$in]': ids
        },
        {
          x_location: toOccurrenceRow,
          y_location: toOccurrenceIndex,
          project_id: projectId,
          condition_id: conditionId
        }
      );
    }

    dispatch(getProjectConditions(occurrence.project_id));

    callback && callback();

    return true;
  };
};

export const createOccurrenceLocation = (
  occurrence,
  toOccurrenceRow,
  toOccurrenceIndex,
  toConditionIndex,
  callback
) => {
  return async (dispatch, getState, { apiClient }) => {
    const conditionId = getState().projects.single.conditions[toConditionIndex].id;
    occurrence.x_location = toOccurrenceRow;
    occurrence.y_location = toOccurrenceIndex;
    occurrence.condition_id = conditionId;

    if (occurrence.id) {
      delete occurrence.id;
    }

    const res = await apiClient.call(
      OCCURRENCE_LOCATION_TAG,
      'createOccurrenceLocation',
      {},
      occurrence
    );

    occurrence.id = res.id;

    dispatch(getProjectConditions(occurrence.project_id));

    callback && callback();

    return true;
  };
};

export const deleteOccurrenceLocation = (occurrence, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    if (!isArray(occurrence)) {
      await apiClient.call(OCCURRENCE_LOCATION_TAG, 'deleteOccurrenceLocation', {
        id: occurrence.id
      });
    } else {
      const ids = [];
      occurrence.forEach(occ => {
        ids.push(occ.id);
      });
      await apiClient.call(OCCURRENCE_LOCATION_TAG, 'deleteOccurrenceLocationStack', {
        'id[$in]': ids
      });
    }

    dispatch(getProjectConditions(occurrence.project_id));

    callback && callback();

    return true;
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/experimentalDesign/occurrenceLocationAction.js